import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ApplicationLogDate {
  date: string;
}

export interface ApplicationLogContent {
  date: string;
  content: string;
  page: number;
  totalPages: number;
}

export interface ApplicationLogLevel {
  level: string;
}

@Injectable({ providedIn: 'root' })
export class ApplicationLogsService {
  private readonly url = environment.urls.baseApiUrl + '/ApplicationLogs';

  constructor(private http: HttpClient) { }

  /** Loads the retained dates exposed by the Super Administrator log API. */
  getDates(): Observable<ApplicationLogDate[]> {
    return this.http.get<ApplicationLogDate[]>(this.url);
  }

  /**
   * Loads the newest retained log content for a date.
   * @param date Date formatted as yyyy-MM-dd.
   * @param page One-based page number ordered from newest to oldest.
   */
  getByDate(date: string, page: number): Observable<ApplicationLogContent> {
    const options = { params: { page: page.toString() } };
    return this.http.get<ApplicationLogContent>(this.url + '/' + date, options);
  }

  /** Loads the active Serilog minimum level for a Super Administrator. */
  getLevel(): Observable<ApplicationLogLevel> {
    return this.http.get<ApplicationLogLevel>(this.url + '/Level');
  }

  /**
   * Changes the persisted Serilog minimum level.
   * @param level Valid Serilog event level name.
   */
  updateLevel(level: string): Observable<ApplicationLogLevel> {
    return this.http.put<ApplicationLogLevel>(this.url + '/Level', { level });
  }
}
